module.exports = __webpack_public_path__ + "static/media/frizo-book.ae855a66.png";